import React, { Component } from 'react'
import { LoginStyle } from './style'
import LoginPanel from './components/LoginPanel'
import NonSSOLogin from './components/NonSSOLogin';

export default class Login extends Component {
  render() {
    return (
      <LoginStyle>
        { process.env.REACT_APP_OVERRIDE_LOGIN_METHOD === 'legacy' ? <NonSSOLogin /> : <LoginPanel />}
      </LoginStyle>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Auth/index.js